import { httpRequest } from "../../http";
import {
  EngagementActivityEntry,
  EngagementConfigVersion,
  EngagementConfigVersionSnapshot,
} from "@models/engagementConfigVersion.model";

const base = (engagementId: number) =>
  `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/config-versions/`;

export class CommandListEngagementVersions {
  async run(engagementId: number): Promise<EngagementConfigVersion[]> {
    return httpRequest<EngagementConfigVersion[]>(base(engagementId), { method: "GET" });
  }
}

/**
 * Just the number, for the History button's badge.
 *
 * Separate from the list because the list renders: the server reads a window of snapshots
 * and diffs each consecutive pair on every call, which is why it is only fetched when the
 * drawer opens. A badge is worth one COUNT, not that.
 */
export class CommandCountEngagementVersions {
  async run(engagementId: number): Promise<number> {
    const { count } = await httpRequest<{ count: number }>(`${base(engagementId)}count/`, {
      method: "GET",
    });
    return count;
  }
}

export class CommandGetEngagementVersionSnapshot {
  async run(engagementId: number, versionId: number): Promise<EngagementConfigVersionSnapshot> {
    const url = `${base(engagementId)}${versionId}/snapshot/`;
    return httpRequest<EngagementConfigVersionSnapshot>(url, { method: "GET" });
  }
}

export class CommandGetEngagementActivity {
  async run(engagementId: number): Promise<EngagementActivityEntry[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/activity/`;
    return httpRequest<EngagementActivityEntry[]>(url, { method: "GET" });
  }
}
